import React from "react"
import { /* Row, Col,  */Toast/* , Button  */} from "react-bootstrap"

export class QuickToast extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.show,
        };
    }
    render() {
        const { show, title, message } = this.props
        const toggleShow = () => this.props.setShow(!show)
        return (
            <div xs={12} style={{position: "absolute", right: "5vw", top: "10vh", zIndex: "100"}}>
                <Toast show={show} onClose={toggleShow}>
                    <Toast.Header className={title !== "Error" ? "bg-success" : "bg-danger"}>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded mr-2"
                            alt=""
                        />
                        <strong className="mr-auto">{title || "Sin Titulo"}</strong>
                    </Toast.Header>
                    <Toast.Body>
                        {message || "Sin Mensaje"}
                    </Toast.Body>
                </Toast>
            </div>
        );
    }
}

